module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "copyrightPage"
    }
  }, [_c('p', {
    staticClass: "copyrightTextS"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Published by")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Grub Street"), _c('br'), _vm._v("4 Rainham Close"), _c('br'), _vm._v("London")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("SW11 6SS")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Copyright © Grub Street 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Copyright text © Dr Steve Bond 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Copyright foreword © Air Marshal Sir Roger Austin KCB AFC FRAeS RAF")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("2010")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1-1"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("British Library Cataloguing in Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Bond, Steve.")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Heroes all : airmen of different nationalities tell their stories of service in the Second World War.")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("1. World War, 1939-1945--Aerial operations. 2. World War,")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("1939-1945--Personal narratives.")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("I. Title"), _c('br'), _vm._v("940.5’44’0922-dc22")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("ISBN-13: 9781906502713")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("eISBN: 9781908117861")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means electronic, mechanical, photocopying, recording or otherwise, without the prior permission of the copyright owner.")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Cover design and typesetting by Sarah Driver")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Edited by Sophie Campbell")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Printed and bound by MPG Ltd, Bodmin, Cornwall")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Grub Street Publishing only uses")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("FSC (Forest Stewardship Council) paper for its books.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13f8b0bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeroesAll_copyright.vue
// module id = 60
// module chunks = 0